import React, { FC, useRef, useState } from 'react';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';
import useClickAway from '@utils/hooks/useClickOutside';
import classnames from 'classnames/bind';
import styles from './tooltipButton.module.scss';
const cx = classnames.bind(styles);

const Tooltip = () => {
  return (
    <div className={cx('tooltip')}>
      <Icon name="tooltipTopTail" width={8} height={8} fill={Colors.C_COOL_GRAY_70} />
      <div className={cx('tooltipBox')}>
        <div className={cx('tooltipInfoWrap')}>
          <div className={cx('tooltipTitle')}>기술 키워드란?</div>
          <p className={cx('tooltipDesc')}>자신 있는 전문 스킬 또는 활용 가능한 툴을 숙련도와 함께 표현해봐요.</p>
        </div>
        <div className={cx('tooltipInfoWrap')}>
          <div className={cx('tooltipTitle')}>기술 키워드의 숙련도는?</div>
          <p className={cx('tooltipDesc')}>· 기초: 대학교에서 수업을 통해 지식을 학습한 수준</p>
          <p className={cx('tooltipDesc')}>· 초급: 아르바이트/인턴을 통해 업무를 하였거나 활용한 수준</p>
          <p className={cx('tooltipDesc')}>· 중급: 1년 미만 업무에 적용한 경험이 있거나, 실무에 활용 가능한 수준</p>
          <p className={cx('tooltipDesc')}>
            · 고급: 1~3년 동안 업무에 적용한 경험이 있거나, 큰 도움 없이 활용 가능한 수준
          </p>
          <p className={cx('tooltipDesc')}>
            · 전문가: 3년 이상 업무에 적용한 경험이 있거나, 자유자재로 다룰 수 있는 수준
          </p>
        </div>
      </div>
    </div>
  );
};

const TooltipButton: FC = () => {
  const [tooltip, setTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useClickAway(() => setTooltip(false), tooltipRef);

  return (
    <div className={cx('btnInfoArea')} ref={tooltipRef}>
      <a className={cx('btnInfo')} role="button" onClick={() => setTooltip(!tooltip)}>
        <Icon name="informationLight" width={20} height={20} />
        {tooltip && <Tooltip />}
      </a>
    </div>
  );
};

export default TooltipButton;
